import { FC } from "react";

import "./Schedule.scss";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import Card from "components/v2/Card/Card";
import Schedule from "./Schedule";
import { FreightModeBaseTypes } from "../../../../../constants";
import { groupOceanVesselLegs, resolveOceanScheduleUpdated } from "./scheduleUtils";

type ScheduleContainerProps = {
  shipmentDetails: any;
  isShipmentDetailsLoading: boolean;
};

const ScheduleContainer: FC<ScheduleContainerProps> = function (props) {
  const { shipmentDetails, isShipmentDetailsLoading } = props;
  const freightModeType = shipmentDetails?.service?.freight_mode_type;
  const scheduleStops = shipmentDetails?.schedule?.schedule_stops;
  const transitStops = scheduleStops?.filter((item: any) => !["pickup", "delivery"].includes(item.type));
  const vesselScheduleSummary = shipmentDetails?.schedule?.vessel_schedule_summary;
  const oceanVesselLegs =
    freightModeType === FreightModeBaseTypes.OCEAN && transitStops?.length
      ? groupOceanVesselLegs(transitStops)
      : [];
  const isScheduleUpdatedEffective =
    freightModeType === FreightModeBaseTypes.OCEAN
      ? resolveOceanScheduleUpdated(vesselScheduleSummary, shipmentDetails?.schedule?.is_schedule_updated)
      : shipmentDetails?.schedule?.is_schedule_updated;

  /**
   *  only render the schedule section if either data is loading or freight mode is ocean|air or
   *  stops other than pickup|delivery are available or there's no data available to show error state.
   */
  const renderScheduleSection =
    isShipmentDetailsLoading ||
    !scheduleStops ||
    ([FreightModeBaseTypes.AIR, FreightModeBaseTypes.OCEAN].includes(freightModeType) && !!transitStops?.length);

  return renderScheduleSection ? (
    <div>
      <Card borderRadius="md">
        {isShipmentDetailsLoading && <LoadingSkeleton rows={2} />}
        {!isShipmentDetailsLoading && (
          <Schedule
            showErrorState={!scheduleStops}
            transitStops={transitStops}
            freightModeType={freightModeType}
            isScheduleUpdated={isScheduleUpdatedEffective}
            vesselScheduleSummary={vesselScheduleSummary}
            oceanVesselLegs={oceanVesselLegs}
          />
        )}
      </Card>
    </div>
  ) : null;
};

export default ScheduleContainer;
